import { render, staticRenderFns } from "./GridPercentageColumn.vue?vue&type=template&id=a3ad88ee&"
import script from "./GridPercentageColumn.vue?vue&type=script&lang=ts&"
export * from "./GridPercentageColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports